import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "my-1 border-0 d-flex flex-column sidebar-height" }
const _hoisted_2 = {
  class: "d-block nav flex-column m-0 align-items-start",
  id: "menu"
}
const _hoisted_3 = { class: "my-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "sidebar-icon mr-3"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "9 22 9 12 15 12 15 22" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "(current)", -1)
const _hoisted_6 = { class: "my-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "sidebar-icon mr-3"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "16",
    y1: "2",
    x2: "16",
    y2: "6"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "8",
    y1: "2",
    x2: "8",
    y2: "6"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "3",
    y1: "10",
    x2: "21",
    y2: "10"
  })
], -1)
const _hoisted_8 = { class: "my-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "sidebar-icon mr-3"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "7",
    r: "4"
  })
], -1)
const _hoisted_10 = { class: "my-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "sidebar-icon mr-3"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "14 2 14 8 20 8" }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "16",
    y1: "13",
    x2: "8",
    y2: "13"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "16",
    y1: "17",
    x2: "8",
    y2: "17"
  }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "10 9 9 9 8 9" })
], -1)
const _hoisted_12 = {
  key: 0,
  class: "my-1"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "35",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "sidebar-icon mr-3",
  height: "18",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-30 -30 590 590"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z" })
], -1)
const _hoisted_14 = { class: "my-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "sidebar-icon mr-3"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "3",
      y: "4",
      width: "18",
      height: "18",
      rx: "2",
      ry: "2"
    }),
    /*#__PURE__*/_createElementVNode("line", {
      x1: "16",
      y1: "2",
      x2: "16",
      y2: "6"
    }),
    /*#__PURE__*/_createElementVNode("line", {
      x1: "8",
      y1: "2",
      x2: "8",
      y2: "6"
    }),
    /*#__PURE__*/_createElementVNode("line", {
      x1: "3",
      y1: "10",
      x2: "21",
      y2: "10"
    })
  ])
], -1)
const _hoisted_16 = {
  key: 1,
  class: "my-1"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "sidebar-icon mr-3"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "9",
    cy: "7",
    r: "4"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
], -1)
const _hoisted_18 = {
  key: 2,
  class: "my-1"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "sidebar-icon mr-3"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "2",
    y: "7",
    width: "20",
    height: "14",
    rx: "2",
    ry: "2"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" })
], -1)
const _hoisted_20 = {
  key: 3,
  class: "my-1"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "sidebar-icon mr-3"
}, [
  /*#__PURE__*/_createElementVNode("polygon", { points: "12 2 2 7 12 12 22 7 12 2" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "2 17 12 22 22 17" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "2 12 12 17 22 12" })
], -1)
const _hoisted_22 = { class: "my-1" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "45",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "sidebar-icon mr-3",
  height: "18",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-30 -30 590 590"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z" })
], -1)
const _hoisted_24 = { class: "d-block nav flex-column m-0 mt-auto" }
const _hoisted_25 = { class: "my-1" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "sidebar-icon mr-3"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "14 2 14 8 20 8" }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "16",
    y1: "13",
    x2: "8",
    y2: "13"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "16",
    y1: "17",
    x2: "8",
    y2: "17"
  }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "10 9 9 9 8 9" })
], -1)
const _hoisted_27 = { class: "my-1" }
const _hoisted_28 = {
  class: "text-secondary fs-11 pl-4",
  id: "releaseVersion"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "nav-link-white pl-4",
          to: { name: 'Dashboard' }
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Dashboard "),
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createVNode(_component_router_link, {
          class: "nav-link-white pl-4",
          to: { name: 'Leaves', params: { id: _ctx.id, name: _ctx.name } }
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createTextVNode(" Book Leaves ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createVNode(_component_router_link, {
          class: "nav-link-white pl-4",
          to: { name: 'Emergency Contact' }
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _createTextVNode(" My Emergency Contacts ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_10, [
        _createVNode(_component_router_link, {
          class: "nav-link-white pl-4",
          to: { name: 'My Documents' }
        }, {
          default: _withCtx(() => [
            _hoisted_11,
            _createTextVNode(" My Documents ")
          ]),
          _: 1
        })
      ]),
      (_ctx.tokenData.Roles == 'Employee')
        ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
            _createVNode(_component_router_link, {
              class: "nav-link-white pl-4",
              to: { name: 'Finder' }
            }, {
              default: _withCtx(() => [
                _hoisted_13,
                _createTextVNode(" Finder ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_14, [
        _createVNode(_component_router_link, {
          class: "nav-link-white pl-4",
          to: { name: 'Rosters' }
        }, {
          default: _withCtx(() => [
            _hoisted_15,
            _createTextVNode(" Rosters ")
          ]),
          _: 1
        })
      ]),
      (
          _ctx.tokenData.Roles == 'Org Admin' ||
          _ctx.tokenData.Roles == 'Manager' ||
          _ctx.tokenData.Roles == 'Admin'
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
            _createVNode(_component_router_link, {
              class: "nav-link-white pl-4",
              to: { name: 'Employees' }
            }, {
              default: _withCtx(() => [
                _hoisted_17,
                _createTextVNode(" Employees ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.tokenData.Roles == 'Org Admin' ||
          _ctx.tokenData.Roles == 'Manager' ||
          _ctx.tokenData.Roles == 'Admin'
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
            _createVNode(_component_router_link, {
              class: "nav-link-white pl-4",
              to: { name: 'Department' }
            }, {
              default: _withCtx(() => [
                _hoisted_19,
                _createTextVNode(" Departments ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.tokenData.Roles == 'Org Admin' ||
          _ctx.tokenData.Roles == 'Manager' ||
          _ctx.tokenData.Roles == 'Admin'
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
            _createVNode(_component_router_link, {
              class: "nav-link-white pl-4",
              to: { name: 'Manage Documents' }
            }, {
              default: _withCtx(() => [
                _hoisted_21,
                _createTextVNode(" Manage Documents ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_22, [
        _createVNode(_component_router_link, {
          class: "nav-link-white pl-4",
          to: { name: 'Settings' }
        }, {
          default: _withCtx(() => [
            _hoisted_23,
            _createTextVNode(" Settings ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("ul", _hoisted_24, [
      _createElementVNode("li", _hoisted_25, [
        _createVNode(_component_router_link, {
          class: "nav-link-white pl-4",
          to: { name: 'Feedback' }
        }, {
          default: _withCtx(() => [
            _hoisted_26,
            _createTextVNode(" Feedback ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_27, [
        _createElementVNode("span", _hoisted_28, _toDisplayString("v " + _ctx.releaseVersion || "N/A"), 1)
      ])
    ])
  ]))
}